import { render, staticRenderFns } from "./Dialog_ChangeStudentPhone.vue?vue&type=template&id=4913ca6c&scoped=true&"
import script from "./Dialog_ChangeStudentPhone.vue?vue&type=script&lang=js&"
export * from "./Dialog_ChangeStudentPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4913ca6c",
  null
  
)

export default component.exports